import TeamManagementList from './TeamManagementList';

export default TeamManagementList;
